export default __webpack_public_path__ + "static/media/lead.b4be2200.jpg";